import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const FullscreenLoader = () => (
  <div
    data-testid="auth-loading"
    className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-300"
  >
    <Loader2 className="animate-spin mr-3" size={22} />
    <span className="font-mono text-sm">Memeriksa sesi…</span>
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false, roles = null }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) return <FullscreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  // A3: temporary password + owner setting on -> change it first (the server enforces this too)
  if (user.wajib_ganti_password && location.pathname !== "/ganti-password") return <Navigate to="/ganti-password" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
